import {
    allVariants,
    collection,
    parentTypeFor,
    routePath
} from "../_variants/index.js";
import {
    editEAR,
    revisionRollback
} from "./actions";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import { revisions as _revisions } from "../../standardAttachables";
// import eafAttachable from "../EAF/attachable.js";
import flightAttachables from "../FlightConditions/attachable?test";
import { makeDesignChangeAttachable } from "../DesignChanges/attachable.js";
import { makeEADTAttachable } from "../EADTs/attachable.js";
import partNumbers from "../ApprovedPartNumbers/attachable";

const revisions = {
    ..._revisions,
    "headers": [
        ..._revisions.headers
    ],
    "actions": [{
        "label": "Rollback Revision",
        "action": revisionRollback,
        show({ pageItem }) {
            return [Object.keys(pageItem.Revisions).length > 1, "No previous revisions found"];
        }
    }],
    "rowActions": [{
        "label": "View Archived File",
        async action({ toast, pageItem, rowItem, db }) {
            try {
                let docNumber = pageItem.Number.replace(".", "_");
                let rev = rowItem.Revision;
                let url = await db.download(`Database/Documents/${pageItem.ID}/${docNumber}_${rev}.pdf`);
                window.open(url, "__blank")
            } catch (err) {
                toast.error("Archive file not found");
            }
        }
    }]
};

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Parent",
    "key": "Parent",
    "link": "Database/:ParentType/:ParentID"
}, {
    "label": "Mod Type",
    "key": "Type"
}, {
    "label": "Date Created",
    "key": "Date.Created",
    "type": "date"
}, {
    "label": "Date Completed",
    "key": "Date.Completed",
    "type": "date"
}, {
    "label": "Title",
    "key": "Title",
    "class": "md:col-span-3"
}];

const menuActions = [{
    "label": "Edit EAR",
    action: editEAR
}];

/**
 * Build the list + detail vue-router routes for the EAR register matching
 * the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeEARRoutes = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military EAR" : "EAR";
    const labelPlural = isMilitary ? "Military EARs" : "EARs";
    const earParentType = parentTypeFor(variant, "EARs");
    const listPath = routePath(variant, "EARs");
    // EARs historically present themselves to children as ParentType="Documents"
    // (semantic), but writes go to the variant's Documents collection.
    const docParentType = parentTypeFor(variant, "Documents");

    return [{
        "path": listPath,
        "component": { ...ItemListView },
        "name": labelPlural,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "sideNav": true,
            "sideNavSection": "Equipment Assessments",
            "appSwitcher": false,
            "icon": variant.appIcon,
            "tableSettings": earParentType,
            "dataPath":"Database/EARs",
            "selectionRoute": `Database/${earParentType}/{ID}`,
        }
    }, {
        "path": `${listPath}/:id`,
        "component": ItemView,
        "name": labelSingular,
        "meta": {
            "app": variant.app,
            "name": labelSingular,
            "dataPath": collection(variant, "EARs"),
            "selectionRoute": `Database/${earParentType}/{ID}`,
            "storeData": ["Database/DocumentTypes", "Database/Regulations/CS25"],
            title(item) {
                return `Documents: ${item.Number}`
            },
            "attachedItems": {
                "Revisions": {
                    "attachables": [revisions]
                },
                "Equipment Assessments": {
                    "attachables": [makeEADTAttachable(variant), partNumbers]
                },
                "Designs": {
                    "attachables": [makeDesignChangeAttachable(variant), flightAttachables]
                }
            },
            "dataFields": dataFields,
            "menuActions": menuActions,
            "formMetadata": {
                "ParentType": docParentType
            }
        }
    }];
};

export default allVariants().flatMap(makeEARRoutes);
